import type { RouteObject } from "react-router-dom";
import { PagesFranchiseManagementUiDisplay } from "./Display";
import { AddFranchise } from "./Display/AddFranchise";

export const PagesFranchiseManagementUiRoutes: RouteObject[] = [
  {
    path: "franchiseManagement",
    element: <PagesFranchiseManagementUiDisplay />,
    children: [
      {
        path: "add",
        element: <AddFranchise />
      }
    ]
  }
];
